export const categories = [
  { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html', imageSeq: 'cat-shoes-01' },
  { name: 'Hoodies/Sweaters', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html', imageSeq: 'cat-hoodies-01' },
  { name: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html', imageSeq: 'cat-tshirts-01' },
  { name: 'Jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html', imageSeq: 'cat-jackets-01' },
  { name: 'Pants/Shorts', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html', imageSeq: 'cat-pants-01' },
  { name: 'Headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html', imageSeq: 'cat-headwear-01' },
  { name: 'Sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html', imageSeq: 'cat-sets-01' },
  { name: 'Underwear/Underpants', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html', imageSeq: 'cat-underwear-01' },
  { name: 'Jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html', imageSeq: 'cat-jersey-01' },
  { name: 'Accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html', imageSeq: 'cat-accessories-01' },
  { name: 'Bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html', imageSeq: 'cat-bags-01' },
  { name: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html', imageSeq: 'cat-belts-01' },
  { name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html', imageSeq: 'cat-perfumes-01' },
  { name: 'Other Stuff', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html', imageSeq: 'cat-other-01' },
];

export const testimonials = [
  {
    headline: 'Best research tool for reps',
    body: 'Superbuy Sheet completely changed how I find and organize fashion items. The spreadsheet system saved me literally dozens of hours every month comparing products across different sellers.',
    author: 'Marcus Reynolds',
    role: 'Fashion Reseller, NYC',
  },
  {
    headline: 'Found gems I never would have',
    body: 'Before using Superbuy Sheet, I was manually scrolling through listings for hours. Now I have a structured system that lets me spot the best deals in minutes rather than days.',
    author: 'Chloe Wang',
    role: 'Streetwear Collector',
  },
  {
    headline: 'Worth every penny for serious buyers',
    body: 'The category breakdown and organized spreadsheet approach is exactly what the rep community needed. My haul quality went way up after I started using these research methods.',
    author: 'Jayden Okonkwo',
    role: 'Sneaker Enthusiast',
  },
  {
    headline: 'Made my first haul a breeze',
    body: 'I was so overwhelmed as a beginner until I discovered Superbuy Sheet. The guides walked me through everything step by step, from QC photos to shipping consolidation.',
    author: 'Sophie Laurent',
    role: 'First-time Buyer',
  },
  {
    headline: 'Spreadsheet system is genius',
    body: 'The way Superbuy Sheet organizes product data across categories is incredibly intuitive. I can track prices, compare quality, and make decisions faster than ever before.',
    author: 'Daniel Park',
    role: 'Vintage Archive Owner',
  },
  {
    headline: 'Honestly a game changer',
    body: 'I have been in the rep game for 3 years and wish I found Superbuy Sheet sooner. The research templates alone have improved my success rate with finding top-tier products.',
    author: 'Amina Okoro',
    role: 'Fashion Community Moderator',
  },
];

export const seoArticle = {
  title: 'Superbuy Sheet: The Ultimate Product Research Spreadsheet System for Smarter Shopping in 2026',
  slug: 'superbuy-sheet-guide',
  excerpt: 'Discover how Superbuy Sheet transforms chaotic product hunting into an organized, efficient research process. From category breakdowns to QC comparison templates, learn the complete spreadsheet methodology that saves serious shoppers hours of manual browsing.',
  category: 'Beginner Guide',
  imageSeq: 'article-hero-01',
};

export const articleCards = [
  {
    title: 'Superbuy Sheet Ultimate Guide 2026',
    slug: 'superbuy-sheet-guide',
    excerpt: 'Master the spreadsheet system that organized shoppers use.',
    isNew: false,
    imageSeq: 'article-card-01',
  },
  {
    title: 'How To Use Superbuy Sheet: Complete Tutorial',
    slug: 'how-to-use-superbuy-sheet',
    excerpt: 'Step-by-step guide to set up and master your research system.',
    isNew: true,
    imageSeq: 'article-card-02',
  },
  {
    title: 'Shipping Strategy: Save 30% on Haul Costs',
    slug: 'superbuy-shipping-strategy-guide',
    excerpt: 'Weight optimization, line comparisons, and customs tips.',
    isNew: true,
    imageSeq: 'article-card-03',
  },
];